import ForwardArrowIcon from 'components/elements/icons/ForwardArrowIcon'
import Text from 'components/elements/texts/Text'
import { CLIENT_SETTINGS } from 'constants/clientSettings'
import { HistoryStackContext } from 'contexts/HistoryStackContext'
import React, { useCallback, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { transitionWithAction } from 'utils/commonUtils'

import ItemLine from './ItemLine'

/**
 * 選択リンク
 */
const SelectLinkLine: React.FC<SelectLinkLineProps> = (props) => {
  const history = useHistory()
  const historyStackContext = useContext(HistoryStackContext)

  const linkClick = useCallback((): void => {
    transitionWithAction(historyStackContext, props.lineLabel, () => {
      history.push(props.forwardTo)
    })
  }, [props.lineLabel, props.forwardTo])

  return (
    <ItemLine onClick={linkClick}>
      <TextArea>
        <Text>{props.lineLabel}</Text>
      </TextArea>
      <ArrowTextArea>
        <Text>{props.arrowLabel}</Text>
      </ArrowTextArea>
      <ForwardArrowIcon color={CLIENT_SETTINGS.colors.main} />
    </ItemLine>
  )
}

export type SelectLinkLineProps = {
  forwardTo: string
  lineLabel: string
  arrowLabel: string
}
const TextArea = styled.div`
  flex: 1;
  margin-left: 18px;
`
const ArrowTextArea = styled.div`
  flex: 1;
  margin-right: 10px;
  text-align: right;
`

export default SelectLinkLine
